/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { ILandingDelimiterEdge } from "src/modules/pe-landing-module/data/interfaces"

export interface IDelimiterEdge {
	item: ILandingDelimiterEdge 
	clipPathType: CLIP_PATH_TYPE
}
export enum CLIP_PATH_TYPE {
	SHUTE_RIGHT = "shuteRight",
	SHUTE_LEFT = "shuteLeft", 
}
export default function Edge30 (props: IDelimiterEdge): JSX.Element {
	const [id, ] 	= useState<ID>( getID("edge") )
	const [height,] = useState<any>( getCssDemention(props.item.position?.height, "auto") )
	useEffect(() => {
		addCSSClass(
			`edge-${id}`,
			`.edge-${id} {
				${
					!!props.item.position
						?
						`width: ${getCssDemention(props.item.position.width, "calc(100% + 120px)")}!important;
						height: ${height}!important;
						z-index: ${getCssDemention(props.item.position.z, "1")}!important;
						transform: translateX(${getCssDemention(props.item.position.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
						`
						:
						`position: relative;`
				}
			}`
		)
		return () => {
			removeCSSClass(`edge-${id}`)
		}
	},[])
	const getClip = () => {
		switch(props.clipPathType) {
			case CLIP_PATH_TYPE.SHUTE_LEFT:
				return `polygon(0 0, 100% ${height}, 0 ${height})`
			case CLIP_PATH_TYPE.SHUTE_RIGHT:
			default:
				return `polygon(100% 0, 0% ${height}, 100% ${height})`
		}
	}
	return <div
		style={{
			width: "100%",
			height: props.item.position?.height,
			background: props.item.fill || "var(--main-bg-color)",
			clipPath: getClip(), 
		}}
		className={`landing-delimiter-torn edge-${id}`}
	/> 
}

